import { Component, Input, OnInit} from '@angular/core';

import ActionTypesEnum from '@shared/enums/action-constant.enum';
import { CustomEventService } from '@shared/services/custom-event.service';
import { FormBuilder, FormGroup, } from '@angular/forms';

import { validateFormGroup } from '@shared/utils/form.util';
import { UntilDestroy } from "@ngneat/until-destroy";
import { UpdateAnalysisGitwiserService } from "@shared/services/update-analysis-gitwiser.service";
import { PropertiesService } from "@core/services/properties.service";

@UntilDestroy()
@Component({
  selector: 'app-update-analysis-modal',
  templateUrl: './update-analysis-modal.component.html'
})

export class UpdateAnalysisModalComponent implements OnInit {
  @Input() loading: boolean;
  @Input() title: string;
  @Input() settings: GitwiserDetail.AnalysisSettings;
  @Input() teams: Team.TeamModel[];
  @Input() agilespaceAnalyses: Base.KeyLabelModel[];
  @Input() analysisToJS: any;
  @Input() selectedAgilespaceAnalysisId: string;


  updateAnalysisForm: FormGroup;
  exclusionsList: { label: string; value: string }[] = [];
  dateRangeList: { label: string; value: string }[] = [];
  analysisGitwiser: any;

  constructor(private customEventService: CustomEventService,
              private fb: FormBuilder,
              public propertiesService: PropertiesService,
              private updateAnalysisGitwiserService: UpdateAnalysisGitwiserService) { }

  ngOnInit(): void {

    this.dateRangeList.push(
      { label: 'Last 6 Months', value: 'FROM_LAST_6_MONTHS' },
      { label: 'Last 12 Months', value: 'FROM_LAST_12_MONTHS' },
      { label: 'Last 24 Months', value: 'FROM_LAST_24_MONTHS' },
      { label: 'Last 36 Months', value: 'FROM_LAST_36_MONTHS' },
      { label: 'From Beginning', value: 'FROM_BEGINNING' });

    const { exclusions = [], scorecards = [], analysisDateRange = "", agilespaceAnalyses=[]} = this.settings;
    this.updateAnalysisForm = this.fb.group({
      exclusions: [exclusions, []],
      scorecards: [scorecards, []],
      analysisDateRange: [analysisDateRange, []],
      agilespaceAnalyses: [agilespaceAnalyses,[]],
    });

    this.updateAnalysisGitwiserService.getAnalysisGitwiser().subscribe((data) => {
      this.analysisGitwiser = data;
      this.exclusionsList=data.exclusionPatterns
    });

  }

  resetForm(): void {
    this.updateAnalysisForm.reset();
  }

  cancelForm(): void {
    this.customEventService.announceEvent(ActionTypesEnum.CLOSE_MODAL);
  }

  submitForm(): void {
    validateFormGroup(this.updateAnalysisForm);

    if (this.updateAnalysisForm.invalid) {
      return;
    }

    const formData = {
      ...this.updateAnalysisForm.value
    };
    this.customEventService.announceEvent(ActionTypesEnum.UPDATE_ANALYSIS, formData);
    this.customEventService.announceEvent(ActionTypesEnum.CLOSE_MODAL);
  }
}
